import * as CONST from '../ActionTypes';

const initialState = {
  productTagList: [],
  productTag: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function productTag(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 商品タグ一覧取得
    // -----------------
    case CONST.GET_PRODUCT_TAG_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productTagList: action.payload,
        },
      );
    case CONST.GET_PRODUCT_TAG_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productTagList: [],
        },
      );
    // -----------------
    // 商品タグ詳細取得
    // -----------------
    case CONST.GET_PRODUCT_TAG_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productTag: action.payload,
        },
      );
    case CONST.GET_PRODUCT_TAG_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productTag: {},
        },
      );
    // -----------------
    // 商品タグ削除
    // -----------------
    case CONST.DELETE_PRODUCT_TAG_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_PRODUCT_TAG_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_PRODUCT_TAG_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default productTag;
